import {
  BorderProps,
  ButtonProps,
  TextProps,
} from 'spindl-shared-components';
import { PathButtonProps } from '../../molecules/PathButton';


type PathSelectorInternalProps = {
  button?: ButtonProps;
  label?: TextProps;
  instructions?: TextProps;
  emailPathButton?: PathButtonProps;
  border?: BorderProps;
  cSVPathButton?: PathButtonProps;
};

type PathSelectorPropsValues = {
  '': PathSelectorInternalProps;
};

const propValues: PathSelectorPropsValues = {
  '': {
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    label: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading1',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    emailPathButton: {
    },
    border: {
      colour: 'Subdued',
      type: 'Vertical',
      styleType: 'Default',
    },
    cSVPathButton: {
    },
  },
};

const getProps = (type: string): PathSelectorInternalProps => {
  const values: PathSelectorInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
